import { response } from "app/helpers/commonInterface";
import {
  GET_ALL_COMPLETED_TASK_REPORT_LIST_FAILURE,
  GET_ALL_COMPLETED_TASK_REPORT_LIST_REQUEST,
  GET_ALL_COMPLETED_TASK_REPORT_LIST_SUCCESS,
} from "../actionTypes";
import { taskData } from "./taskDataInterface";

export interface CompletedTaskReportListState {
  loading: boolean;
  completedTaskDetails: response<taskData[]>;
  error: string;
}

interface action {
  type: string;
  payload: any;
}

const initialState: CompletedTaskReportListState = {
  loading: false,
  completedTaskDetails: {},
  error: "",
};


export const getAllCompletedTaskReportListReducer = (
  state = initialState,
  action: action
) => {
  switch (action.type) {
    case GET_ALL_COMPLETED_TASK_REPORT_LIST_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_COMPLETED_TASK_REPORT_LIST_SUCCESS:
      return {
        loading: false,
        completedTaskDetails: action.payload,
        error: "",
      };
    case GET_ALL_COMPLETED_TASK_REPORT_LIST_FAILURE:
      return {
        loading: false,
        completedTaskDetails: {},
        error: action.payload,
      };
    default:
      return state;
  }
};
